import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const usePermissionStore = create((set) => ({
  permissions: [],

  // Function to get permissions
  getPermission: async ({ successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_PERMISSION
      );

      if (response.success) {
        set({
          permissions: response.data?.data || []
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create the permissions
  createPermission: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.CREATE_PERMISSION,
        data
      );

      if (response.success) {
        set((state) => ({
          permissions: [...state.permissions, response.data?.data]
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete permissions
  deletePermission: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_PERMISSION,
        null,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          permissions: state.permissions.filter((source) => source.id !== id)
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update permissions
  updatePermission: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_PERMISSION,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => ({
          permissions: state.permissions.map((source) =>
            source.id === id ? { ...source, ...data } : source
          )
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  }
}));

export default usePermissionStore;
